import React, { FC } from 'react';

import { Enums, Models } from '@components/SurveyBuilder';
import { Date as DateInput } from '@components/SurveyBuilder/components/Blockable/questions/Date';
import { Email } from '@components/SurveyBuilder/components/Blockable/questions/Email';
import { LinearScale } from '@components/SurveyBuilder/components/Blockable/questions/LinearScale';
import { Location } from '@components/SurveyBuilder/components/Blockable/questions/Location';
import { LongText } from '@components/SurveyBuilder/components/Blockable/questions/LongText';
import { MultiSelect } from '@components/SurveyBuilder/components/Blockable/questions/MultiSelect';
import { Number } from '@components/SurveyBuilder/components/Blockable/questions/Number';
import { ShortText } from '@components/SurveyBuilder/components/Blockable/questions/ShortText';
import { SingleSelect } from '@components/SurveyBuilder/components/Blockable/questions/SingleSelect';
import { Website } from '@components/SurveyBuilder/components/Blockable/questions/Website';
import { YesNo } from '@components/SurveyBuilder/components/Blockable/questions/YesNo';

interface Props {
  value: any;
  block: Models.Block;
  onChange: (value: any) => void;
  isMinimized?: boolean;
}

export const BlockableComponentRenderer: FC<Props> = ({ block, onChange, value, isMinimized }) => {
  switch (block.kind) {
    case Enums.Kind.linearScale:
      return (
        <LinearScale
          onChange={onChange}
          className='mt-4'
          options={(block.blockable as Models.Blockable<Enums.Kind.linearScale>).options}
        />
      );
    case Enums.Kind.singleSelect:
      return (
        <SingleSelect
          onChange={onChange}
          wrapperClassName='mt-4'
          other={(block.blockable as Models.Blockable<Enums.Kind.singleSelect>).other}
          options={(block.blockable as Models.Blockable<Enums.Kind.singleSelect>).options}
        />
      );
    case Enums.Kind.multiSelect:
      return (
        <MultiSelect
          onChange={onChange}
          wrapperClassName='mt-4'
          other={(block.blockable as Models.Blockable<Enums.Kind.multiSelect>).other}
          none_of_above={(block.blockable as Models.Blockable<Enums.Kind.multiSelect>).none_of_above}
          options={(block.blockable as Models.Blockable<Enums.Kind.multiSelect>).options}
        />
      );
    case Enums.Kind.yesNo:
      return <YesNo onChange={onChange} wrapperClassName='mt-4' options={['Yes', 'No']} />;
    case Enums.Kind.date:
      return (
        <DateInput
          className='z-50'
          onChange={(date) => onChange(date?.toString())}
          selected={value && typeof value === 'string' ? new Date(value) : null}
        />
      );
    case Enums.Kind.shortText:
      return <ShortText onChange={onChange} value={value || ''} />;
    case Enums.Kind.longText:
      return (
        <LongText
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
          defaultValue={value || ''}
          className='mt-4'
          isMinimized={isMinimized}
        />
      );
    case Enums.Kind.number:
      return <Number onChange={onChange} value={value || ''} />;
    case Enums.Kind.email:
      return <Email onChange={onChange} value={value || ''} />;
    case Enums.Kind.website:
      return <Website onChange={onChange} value={value || ''} />;
    case Enums.Kind.location:
      return <Location id={`location-${block.id}`} onChange={onChange} inputValue={value || ''} />;
  }

  return <></>;
};
